module.exports = __webpack_public_path__ + "static/media/newPalpation.cfb9580a.png";